(function () {
  let dummyVideoFile = null;

  function getDummyVideoFile() {
    if (dummyVideoFile) return dummyVideoFile;

    const bytes = new Uint8Array([
      0x00, 0x00, 0x00, 0x18, 0x66, 0x74, 0x79, 0x70, 0x6d, 0x70, 0x34, 0x32,
      0x00, 0x00, 0x00, 0x00, 0x69, 0x73, 0x6f, 0x6d, 0x69, 0x73, 0x6f, 0x32,
      0x00, 0x00, 0x00, 0x08, 0x66, 0x72, 0x65, 0x65,
      0x00, 0x00, 0x00, 0x08, 0x6d, 0x64, 0x61, 0x74
    ]);

    dummyVideoFile = new File([bytes], 'ugc-no-video.mp4', {
      type: 'video/mp4',
      lastModified: Date.now()
    });

    return dummyVideoFile;
  }

  function initMediaSliders(root) {
    root.querySelectorAll('[data-giga2-track]').forEach((track) => {
      const card = track.closest('.giga2-card__media');
      if (!card || card.dataset.giga2SliderInit === 'true') return;
      card.dataset.giga2SliderInit = 'true';

      const dots = card.querySelectorAll('[data-giga2-dot]');
      if (!dots.length) return;

      function updateActiveDot() {
        const slideWidth = track.clientWidth;
        if (!slideWidth) return;
        const index = Math.round(track.scrollLeft / slideWidth);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }

      track.addEventListener('scroll', () => requestAnimationFrame(updateActiveDot));

      dots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const index = parseInt(dot.dataset.giga2Dot, 10);
          track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
        });
      });

      updateActiveDot();
    });
  }

  function initUgcApply(root) {
    if (!root || root.dataset.ugcApplyInit === 'true') return;
    root.dataset.ugcApplyInit = 'true';

    initMediaSliders(root);
    initPaginationScroll(root);

    const toast = root.querySelector('[data-ugc-apply-toast]');
    const toastText = root.querySelector('[data-ugc-apply-toast-text]');
    const apiEndpoint = root.dataset.apiEndpoint || '';
    const defaultLabel = root.dataset.defaultLabel || 'Prijavi se';
    const loadingLabel = root.dataset.loadingLabel || 'Slanje…';
    const successMessage = root.dataset.successMessage || 'Vaša prijava je uspješno zaprimljena!';

    let toastTimer = null;
    let isSubmitting = false;

    function getCustomerContext() {
      return {
        id: (root.dataset.customerId || window.GIGA_UGC_CUSTOMER_ID || '').trim(),
        email: (root.dataset.customerEmail || window.GIGA_UGC_CUSTOMER_EMAIL || '').trim()
      };
    }

    function getProductData(card, btn) {
      const source = btn || card;
      if (!source) return { sku: '', product: '' };

      return {
        sku: (source.dataset.productSku || card?.dataset.productSku || '').trim(),
        product: (source.dataset.productTitle || card?.dataset.productTitle || '').trim()
      };
    }

    function setSelectedCard(card) {
      root.querySelectorAll('[data-ugc-product-card]').forEach((el) => {
        el.classList.toggle('is-selected', el === card);
      });
    }

    function setButtonLoading(btn, loading) {
      if (!btn) return;
      const textEl = btn.querySelector('.giga2-iconbtn__ugc-text');
      btn.disabled = loading;
      btn.classList.toggle('is-loading', loading);
      btn.setAttribute('aria-busy', loading ? 'true' : 'false');
      if (textEl) textEl.textContent = loading ? loadingLabel : defaultLabel;
    }

    function showToast(message, isError) {
      if (!toast || !toastText) return;

      toastText.textContent = message;
      toast.classList.toggle('is-error', !!isError);
      toast.hidden = false;
      toast.setAttribute('aria-hidden', 'false');
      toast.classList.add('is-visible');

      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => {
        toast.classList.remove('is-visible');
        toast.setAttribute('aria-hidden', 'true');
        window.setTimeout(() => {
          toast.hidden = true;
        }, 350);
      }, 3500);
    }

    async function submitApplication(card, btn) {
      if (isSubmitting) return;

      const { id: customerId, email: customerEmail } = getCustomerContext();
      const { sku, product } = getProductData(card, btn);

      if (!apiEndpoint) {
        showToast(root.dataset.errorNoEndpoint || 'Desila se greška molimo Vas za strpljenje.', true);
        return;
      }

      if (!customerEmail) {
        showToast('Prijava zahtijeva prijavljen nalog. Osvježi stranicu ili se ponovo prijavi.', true);
        return;
      }

      if (!sku || !product) {
        showToast(root.dataset.errorRequired || 'Molimo Vas popunite sva obavezna polja', true);
        return;
      }

      isSubmitting = true;
      setSelectedCard(card);
      setButtonLoading(btn, true);

      try {
        const formData = new FormData();
        formData.append('video', getDummyVideoFile());
        formData.append('customer_id', customerId);
        formData.append('customer_email', customerEmail);
        formData.append('product_sku', sku);
        formData.append('product_title', product);

        const response = await fetch(apiEndpoint, {
          method: 'POST',
          body: formData
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok || data.success === false) {
          throw new Error(data.message || root.dataset.errorGeneric || 'Desila se greška molimo Vas pokušajte ponovo.');
        }

        showToast(successMessage, false);
      } catch (err) {
        showToast(err.message || root.dataset.errorGeneric || 'Desila se greška molimo Vas pokušajte ponovo.', true);
      } finally {
        isSubmitting = false;
        setButtonLoading(btn, false);
      }
    }

    function triggerFromCard(card) {
      if (!card) return;
      const btn = card.querySelector('[data-ugc-select]');
      submitApplication(card, btn);
    }

    root.querySelectorAll('[data-ugc-select]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        submitApplication(btn.closest('[data-ugc-product-card]'), btn);
      });
    });

    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-giga2-dot]')) return;

      const card = e.target.closest('[data-ugc-action-only]');
      if (!card || !root.contains(card)) return;
      if (e.target.closest('[data-ugc-select]')) return;

      e.preventDefault();
      triggerFromCard(card);
    });

    root.querySelectorAll('[data-ugc-action-only] [role="button"][tabindex="0"]').forEach((el) => {
      el.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        triggerFromCard(el.closest('[data-ugc-action-only]'));
      });
    });
  }

  const PAGINATION_SCROLL_KEY = 'ugc-apply-scroll';

  function getScrollTarget(root) {
    return (
      root.querySelector('.ugc-apply__header') ||
      root.querySelector('[data-ugc-apply-picker]') ||
      root
    );
  }

  function scrollToSectionHeader(root) {
    const target = getScrollTarget(root);
    if (!target) return;

    target.scrollIntoView({ behavior: 'auto', block: 'start' });
  }

  function shouldScrollAfterPagination(root) {
    const sectionId = root.dataset.sectionId || '';
    if (sessionStorage.getItem(PAGINATION_SCROLL_KEY) === sectionId) {
      return true;
    }

    const page = new URLSearchParams(window.location.search).get('page');
    return page && page !== '1';
  }

  function initPaginationScroll(root) {
    root.querySelectorAll('.ugc-apply__pagination a[href]').forEach((link) => {
      link.addEventListener('click', () => {
        sessionStorage.setItem(PAGINATION_SCROLL_KEY, root.dataset.sectionId || '');
      });
    });

    if (!shouldScrollAfterPagination(root)) return;

    sessionStorage.removeItem(PAGINATION_SCROLL_KEY);

    const runScroll = () => scrollToSectionHeader(root);
    requestAnimationFrame(() => {
      requestAnimationFrame(runScroll);
    });
  }

  function boot() {
    document.querySelectorAll('[data-ugc-apply]').forEach(initUgcApply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.('[data-ugc-apply]');
    if (root) initUgcApply(root);
  });
})();
